
        <app-public-navigation/>

        <div class="features-container">
            <h1 class="display-4 text-center my-4">Impressum</h1>

            <p class="fw-bold">Für diese Website verantwortlicher Herausgeber</p>

            <p>
                NoteRadar GmbH<br/>
                UID-Nr. ATU76716957
            </p>

            <p class="fw-bold">Firmensitz laut Firmenbuch oder Standort der Gewerbeberechtigung</p>

            <p>
                Badener Straße 6/1b, A-2512 Tribuswinkel, Austria<br/>
                E-Mail: <a href="mailto:office@noteradar.at">office&#64;noteradar.at</a><br/>
                Telefon: +43 677 67701630<br/>
                Internet: <a href="https://www.noteradar.at">www.noteradar.at</a>
            </p>

            <p class="fw-bold">Angaben des Firmenbuches</p>

            <p>Firmenbuchnummer FN 553240p</p>

            <p class="fw-bold">Für das Firmenbuch zuständige Gericht</p>

            <p>Handelsgericht Wr. Neustadt</p>

            <p class="fw-bold">Bankverbindung</p>

            <p>
                Sparkasse Neunkirchen<br/>
                IBAN: AT76 2024 1050 0008 6149<br/>
                BIC: SPNGAT21XXX
            </p>

            <p class="fw-bold">Bildernachweis</p>

            <p>https://unsplash.com/</p>

            <p class="fw-bold">Webdesign / Entwicklung</p>

            <p>2025-{{ currentYear }} by NoteRadar GmbH</p>
        </div>

        <app-public-footer></app-public-footer>
